import differenceInYears from 'date-fns/differenceInYears';

export function validateAgeLimit(date, limit = 100) {
  const birthday = new Date(date);
  const today = new Date(Date.now());

  return differenceInYears(today, birthday) < limit;
}
